<template>
	<div class="content-box">
		<div class="on_sale_table">
			<div class="table" >
				<el-table ref="multipleTable" :height="590" :border="false" :data="tableData" tooltip-effect="dark"
					style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
					<el-table-column width="230" align="center" prop="order_sn" label="订单号">
					</el-table-column>
					<el-table-column align="center" prop="goods_name" label="产品" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="put_time" label="开始投放时间" show-overflow-tooltip>
						<template slot-scope="scope">
							<span>
								{{$getDate(scope.row.put_time)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="投放周期" show-overflow-tooltip>
						<template slot-scope="scope">
							<span>
								{{scope.row.use_week}}周
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="订单类型" show-overflow-tooltip>
						<template slot-scope="scope">
							<span>
								{{scope.row.order_type==0?'首开':'续费'}}
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="add_time"  label="订单创建时间" show-overflow-tooltip>
						<template slot-scope="scope">
							<span>
								{{$getDate(scope.row.add_time)}}
							</span>
						</template>
					</el-table-column>
					
					<el-table-column align="center"  label="状态" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.order_status==1" style="color: #31AC35;">
								交易成功
							</span>
							<span v-else-if="scope.row.order_status==0">
								待支付
							</span>
							<span v-else>
								已取消
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="money_paid"  label="订单金额" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="money_paid"  label="操作" show-overflow-tooltip>
						<template slot-scope="scope">
							<div style="display: flex;align-items: center;">
								<span @click="$router.push('/Home/order_detail?oid='+scope.row.id)" style="color: #1E69FF;cursor: pointer;">
									详情
								</span>
								<span  @click="fcib_order_del(scope.row.id)" v-if="scope.row.order_status==2" style="color: #ff0000;cursor: pointer;margin-left: 15px;">
									删除
								</span>
							</div>
							
						</template>
					</el-table-column>
				</el-table>
			</div>
			<footer class="d-flex j-center a-center">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
				</el-pagination>
			</footer>
			
		</div>
	</div>
	
	
</template>

<script>
	export default{
		data(){
			return{
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
			}
		},
		mounted() {
			this.getOnsalegoods()
		},
		methods:{
			fcib_order_del(id){
				let param = {
					act : 'fcib_order_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					order_id:id
				}
				this.$api.fcib_home_page_tpl_create(param).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
						this.getOnsalegoods()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.getOnsalegoods()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOnsalegoods()
			},
			getOnsalegoods(){
				let param = {
					act : 'ep_order_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.fcib_home_page_tpl_create(param).then((res)=>{
					this.tableData = res.data
					this.total_records = parseInt(res.total_records)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.content-box{
		height: 100%;
		max-width: 73.24rem;
		margin: 0 auto;
	}
	.suojin{
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.on_sale_table{
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}		
		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem; 
			border-radius: 6px;
			padding: 0 1.25rem;
			box-sizing: border-box;
		}
	}
</style>